import { RequestAccessCard } from './request-access-card'

export class RequestAccessCardExport {
  Company_Name: string;
  Request_Number: string;
  Request_Date: Date;
  Request_Type: string;
  Request_Status: string;
  Requestor_Name: string;
  On_Befalf_Of: string;
  Holder: string;
  Access_Card_Type: string;
  Access_Card_Validity: string;
  Request_Reason: string;
  First_Name: string;
  Last_Name: string;
  Job_Title: string;
  Email: string;
  Phone: string;
  Start_Date: Date;
  End_Date: Date;
  Exisiting_Badge_Number: string;
  New_Badge_Number: string; 
  Justification: string;
  Collected_By: string;
  Collected_By_ID: string;
  Access_Card_Request_Type: string;

  constructor(request: RequestAccessCard) {
    this.Company_Name = request.companyName;
    this.Request_Number = request.requestNumber
    this.Request_Date = request.requestDate;
    this.Request_Type =  request.requestTypeName;
    this.Request_Status = request.requestStatusName;
    this.Requestor_Name = request.requestorName;
    this.On_Befalf_Of = request.onBehalfName;
    this.Holder = request.holderName;
    this.Access_Card_Type = request.accessCardTypeName;
    this.Access_Card_Validity = request.accessCardValidityName;
    this.Request_Reason = request.requestAccessCardReasonName;
    this.First_Name = request.firstName;
    this.Last_Name = request.lastName;
    this.Job_Title = request.jobTitle;
    this.Email = request.email;
    this.Phone = request.phone;
    this.Start_Date = request.startDate;
    this.End_Date = request.endDate;
    this.Exisiting_Badge_Number = request.qstpBadgeNumber;
    this.New_Badge_Number = request.newBadgeNumber;
    this.Justification = request.justification;
    this.Collected_By = request.collectedByName;
    this.Collected_By_ID = request.collectedById;
    this.Access_Card_Request_Type = request.accessCardRequestType;
  }
}




// WEBPACK FOOTER //
// ./src/app/core/models/request-access-card-export.ts